module.exports = __webpack_public_path__ + "static/media/google.6044f129.svg";